import { render, staticRenderFns } from "./qrCodeStyling.vue?vue&type=template&id=8f22bb06&scoped=true"
import script from "./qrCodeStyling.vue?vue&type=script&lang=js"
export * from "./qrCodeStyling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f22bb06",
  null
  
)

export default component.exports